<template>
	<div>
		<div class="row">
			<div class="col-sm-12">
				<ul class="uk-breadcrumb">
					<li><a href="/">{{ $t('home') }}</a></li>
					<li><a href="/item-table">{{ $t('product.catalogue') }}</a></li>
					<li class="active">{{ $t('item.view') }}</li>
					<li class="active" v-if="itemData['status']">
            <span class="item-status-inf">
              <span v-for="(val, key) in itemData['status']" v-if="val !== 'NONE'" :class="val === 'TRUE' ? 'completed-status' : 'uncompleted-status'">{{ key }}</span>
            </span>
          </li>
				</ul>
			</div>
		</div>

		<div class="spinner-wrapper">
			<div class="spinner-border" role="status" v-if="$store.getters.getLoadingStatus">
				<span class="sr-only">Loading...</span>
			</div>
		</div>

		<div class="row" v-if="!$store.getters.getLoadingStatus">
			<div class="row" v-if="itemData">
				<div class="col-sm-12">
					<div class="sidebar">
						<template v-if="!history">
							<button v-access:can="Const.PERMISSION_ROLE_EDIT_ITEM" id="sidebar_edit" @click="edit"
									type="submit">
								<span uk-icon="pencil"></span>
								<span class="title">{{ $t('edit') }}</span>
							</button>
							<button v-access:can="Const.PERMISSION_ROLE_EXPORT" onclick="$('#export-form').modal();"
									id="sidebar_export">
								<span uk-icon="upload"></span>
								<span class="title">{{ $t('export') }}</span>
							</button>
						</template>
						<button id="sidebar_groups"
								@click="setTabsVisible()"
								:class="enableGroups ? 'sidebar_marked-button' : ''"
								type="submit">
							<span uk-icon="list"></span>
							<span class="title">{{ $t('enable.disable.groups') }}</span>
						</button>
						<button id="sidebar_help" type="submit">
							<span uk-icon="question"></span>
							<span class="title">{{ $t('help') }}</span>
						</button>
						<span class="title"></span>
					</div>
				</div>
				<div class="col-sm-12">
					<div class="form form-with-sidebar">
						<div class="row">
							<div class="col-sm-12">
								<div class="form-body">
									<tab-header class="row" :tabs-title="attributesGroups" :localization="localization" :activeTab="defaultTab"
												@current-tab="currentTab"/>

									<div class="row">
										<div class="col-sm-12">
											<div class="tab-content">
												<div class="tab-pane" :class="defaultTab === tab.title ? 'active': ''" v-for="tab in attributesGroups" :id="tab.title" :key="tab.title">
													<div class="row" v-if="defaultTab === tab.title || openTabs.includes(tab.title)">
														<div class="row attributes-group-area">
															<div class="col-sm-12"><span>{{ tab.title }}</span></div>
														</div>
														<div v-for="itemCol in splitArr(tab.attributes)" :class="'col-sm-' + 12 / countColumns">
															<AttributeBuilder
																v-for="item in itemCol"
																:key="item.title"
																:item=item
																:item-data="itemData"
																:item-structure="itemStructure"
																:classificators="classificators"
															/>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>

									<div id="item-modifications" class="row"></div>

								</div>
							</div>
						</div>
					</div>

					<div v-access:can="Const.PERMISSION_ROLE_EXPORT" id="export-form" class="modal fade modal-window"
						 tabindex="-1" role="dialog" aria-labelledby="person-users-manager" aria-hidden="true">
						<div class="modal-dialog">
							<div class="modal-content modal-window_rect">

								<div class="export">
									<div class="row">
										<div class="col-sm-6">
											<div class="export-types">
												<ul id="export-types-list"
													class="nav nav-tabs nav-stacked attribute-groups"></ul>
											</div>
										</div>
										<div class="col-sm-6">
											<div class="export-templates">
												<div id="export-templates-list" class="tab-content"></div>
											</div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>
			<div v-else>
				{{ $t('item.not.found') }}
			</div>
		</div>
	</div>
</template>

<script>
import TabHeader from 'components/item-edit/TabHeader'
import AttributeBuilder from 'components/item-view/AttributeBuilder'
import { countColumns, mapAttrTabs, chunkTabAttribute } from '@/services/shared'
import { CONFIGURATIONS_ITEM_VIEW } from 'actions/configurations'
import { ItemViewProcessor } from '@/core/item_assistance/itemViewProcessor'
import { initTabAction } from '@/core/item_assistance/initItemData'
import { initModificationInfoForView } from '@/core/item_assistance/itemAdditionals'
import { initSidebar } from '@/core/support_gui_components/sidebar/sidebar'
import { bindExportFormAction, configureExport } from '@/core/migration/ExportManager'
import { enableAllHotkeysForAttributeGroups, enableHotkeyForEdit } from '@/core/hotkey/HotkeyFunctions'
import { isGroupMode, setTabsVisible } from '@/core/core_components/form/form'
import { flatDeepAttributes } from 'utils/format'
import { getLocalizedMessage, showMessageAlert } from '@/core/shared'

export default {
	name: 'ItemView',
	metaInfo () {
		return {
			title: this.$t('item.view')
		}
	},
	components: {
		TabHeader,
		AttributeBuilder
	},
	props: {
		id: {
			type: String
		},
		history: {
			type: Boolean,
			default: false
		}
	},
	data () {
		return {
			itemStructure: [],
			itemData: null,
			attributesGroups: [],
			localization: {},
			language: [],
			countColumns: countColumns(),
			enableGroups: false,
			classificators: [],
			defaultTab: '',
			openTabs: [],
		}
	},
	methods: {
		getConfiguration: function () {
			const url = this.history ? `/items/history/${this.id}/load` : `/items/${this.id}/load`
			this.$store.dispatch(CONFIGURATIONS_ITEM_VIEW, url)
				.then(() => {
					this.attributesGroups = this.$store.getters.getAttributesGroups
					this.language = this.$store.getters.getLanguage
					this.itemStructure = this.$store.getters.getItemStructure
					this.classificators = this.$store.getters.getClassificators

					if (this.$store.getters.getItemData.length === 0) {
						showMessageAlert(getLocalizedMessage("error"), 'danger', getLocalizedMessage('item.not.found'));
						throw new Error(this.$t('item.not.found'));
					} else {
						this.itemData = this.$store.getters.getItemData
					}
				})
				.then(() => {
					this.setDefaultTab()
					this.initViewTradeItem()
				})
				.catch(errors => {
					console.error(errors)
					this.rollbar.error('CONFIGURATIONS_ITEM_VIEW', errors)
				})
		},
		initViewTradeItem: function () {
			window.viewTradeItem = new ItemViewProcessor()
			viewTradeItem.setItemStructure(this.itemStructure)
			// viewTradeItem.setItemData(${itemData})
			viewTradeItem.setAttributesGroups(this.attributesGroups)
			viewTradeItem.setLocalization(this.localization)
			viewTradeItem.setLanguage(this.language)

			$(document).focus()
			initTabAction()
			initModificationInfoForView()
			initSidebar(['edit', 'export', 'groups', 'help'])

			configureExport()
			bindExportFormAction(this.id, 'view')

			//hotkeys
			enableAllHotkeysForAttributeGroups()
			enableHotkeyForEdit()
		},
		splitArr: function (arr) {
			let mapAttr = []
			this.removeEmptyAttribute(arr)
			mapAttrTabs(arr, mapAttr, this.itemStructure, this.language)
			return chunkTabAttribute(mapAttr, arr)
		},
		removeEmptyAttribute: function (arr) {
			let that = this
			arr.forEach(function (value, index) {
				if (value.type === 'CONTAINER') {
					if (value.attributes.length < 1) {
						arr.splice(index, 1)
					} else {
						that.removeEmptyAttribute(value.attributes)
					}
				} else {
					if (!that.itemData.hasOwnProperty(value.title)) {
						arr.splice(index, 1)
					}
				}
			})
		},
		edit: function () {
			location.href = '/item-edit/' + this.id
		},
		setTabsVisible: function () {
			this.attributesGroups.forEach(a => {
				if (!this.openTabs.includes(a.title)) {
					this.openTabs.push(a.title)
				}
			})

			this.$nextTick(() => {
				const isGroup = !isGroupMode()
				setTabsVisible(isGroup)
				this.enableGroups = isGroup
			})
		},
		currentTab: function (tab) {
			if (!this.openTabs.includes(tab)) {
				this.openTabs.push(tab)
			}
			this.defaultTab = tab
		},
		setDefaultTab: function () {
			const attributesGroups = this.attributesGroups
			const activeAttr = this.activeAttribute
			let activeTab = attributesGroups[0].title

			if (!activeAttr) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
				return
			}

			attributesGroups.forEach(a => {
				let attr = flatDeepAttributes(a.attributes)
				if (attr.includes(activeAttr)) {
					activeTab = a.title
				}
			})

			if (activeTab) {
				this.defaultTab = activeTab
				this.openTabs = [this.defaultTab]
			}
		}
	},
	mounted() {
		this.getConfiguration()
	}
}
</script>

<style scoped>
	.attribute__group {
		display: inline-block;
		border: 2px solid #ccc;
		padding: 0 15px 15px 15px;
		margin: 10px 10px 10px 0;
		width: 100%;
	}
	.attribute__group-title {
		font-weight: 600;
		position: relative;
		width: max-content;
		top: -10px;
		background-color: #fff;
		padding: 0 5px;
		margin: 0
	}
	.spinner-wrapper {
		display: flex;
		justify-content: center;
	}

	.spinner-border {
		display: inline-block;
		width: 2rem;
		height: 2rem;
		vertical-align: text-bottom;
		border: .25em solid #ececec;
		border-right-color: transparent;
		border-radius: 50%;
		-webkit-animation: spin .75s linear infinite;
		animation: spin .75s linear infinite;
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
</style>
